import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

export function AuthFrame({ eyebrow, title, description, children, footer }: {
  eyebrow: string;
  title: string;
  description: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <main className="auth-page blueprint-bg">
      <section className="auth-brand-panel">
        <div className="brand-mark large">TRP</div>
        <p className="eyebrow light">The Rebuild Process</p>
        <h1>You’re not broken.<br />You’re underbuilt.</h1>
        <p>And because you’re underbuilt, you can rebuild. That’s the work.</p>
        <div className="auth-principles">
          <span>Learn it.</span><span>Build it.</span><span>Live it.</span>
        </div>
      </section>
      <section className="auth-card-wrap">
        <div className="auth-card">
          <Link to="/hub" className="auth-wordmark">The Rebuild Hub</Link>
          <p className="eyebrow">{eyebrow}</p>
          <h2>{title}</h2>
          <p className="auth-description">{description}</p>
          {children}
          {footer && <div className="auth-footer">{footer}</div>}
        </div>
      </section>
    </main>
  );
}
